import React from 'react';
import { Droppable, Draggable } from 'react-beautiful-dnd';
import { COLORS } from '../../styles/colors';
import ExercisePlaceholder from './ExercisePlaceholder';
import SandboxPlanItem from './SandboxPlanItem';
import SandboxBlockItem from './SandboxBlockItem';
import SandboxCircuitItem from './SandboxCircuitItem';
import { ConfirmJsMessage } from './../../helpers.js'

import SandboxContent from './SandboxContent';
const REMOVE_CIRCUIT_PROMPT = `Are you sure you want to remove this circuit and all its exercises?`;
const getItemStyle = (isDragging, draggableStyle) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: 'none',
  border: '1px solid ' + COLORS.grey,

  // change background colour if dragging
  // background: isDragging ? 'lightgreen' : 'transparent',

  // styles we need to apply on draggables
  ...draggableStyle
});

const getListStyle = isDraggingOver => ({
  borderLeft: "1px solid " + COLORS.grey,
  height: '100%',
  paddingBottom: 10,
  overflow: 'auto',
  maxHeight: 450
  // background: isDraggingOver ? 'lightblue' : 'transparent'
});

const Sandbox = ({ items, remove, copyItem, id, edit, showBlockDetails, draggingItem }) => {
  items = items.filter(i => !i.deleted);
  const ItemContent = ({item}) => {
    if (item.formData && item.type === 'plan') {
      return (
        <SandboxPlanItem
          item={item}
          remove={() => remove(item)}
          edit={() => edit(item)}
          copyItem={ () => copyItem(item) }
          />
      )
    }
    if (item.type === 'circuit') {
      return (
        <SandboxCircuitItem
          item={item}
          remove={() => {
            if (ConfirmJsMessage(REMOVE_CIRCUIT_PROMPT)) {
              remove(item);
            }
          }}
          edit={() => edit(item)}
        />
      )
    }
    if (item.type === 'block') {
      return (
        <SandboxBlockItem
          item={item}
          remove={() => remove(item)}
          openBlockDetails={() => showBlockDetails(item.data._id)}
          />
      )
    }
    return null;
  }

  const CircuitPrompt = ({item, index}) => {
    if (items[index+1]) {
      if (item.type === 'circuit' && items[index+1].parent === item.id ) {
        return (
          <ExercisePlaceholder short={true} />
        )
      }
    }
    return null;
  }
  let placeholderText = '';
  if (draggingItem) {
    placeholderText = draggingItem.type === 'circuit'
      ? "DROP CIRCUIT ROUND HERE"
      : "DROP EXERCISE HERE";
  }
  return (
    <Droppable droppableId={id}>
      {(provided, snapshot) => (
        <div
          ref={provided.innerRef}
          style={getListStyle(snapshot.isDraggingOver)}>
          {
            items.length ? (
              items.map((item, index) => {
                const dragObject = (
                  <Draggable
                    draggableId={item.id}
                    isDragDisabled={item.type === 'circuit'}
                    index={index}>
                    {(provided, snapshot) => (
                      <div
                        style={{zIndex:500, position:'relative'}}>
                        <div
                          id={item.id + index}
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          style={getItemStyle(
                              snapshot.isDragging,
                              provided.draggableProps.style
                          )}>

                          <ItemContent item={item}/>
                        </div>
                        <CircuitPrompt item={item} index={index} />
                      </div>
                    )}
                </Draggable>
              );
                return (
                  <SandboxContent
                    dragId={item.id + index}
                    key={item.id}
                    draggingItem={draggingItem}
                    isHoveringOver={snapshot.isDraggingOver}
                    Draggable={dragObject}
                  />
                )
              }
            )
          ): (
            <ExercisePlaceholder show={!snapshot.isDraggingOver }/>
          )

          }
          {snapshot.isDraggingOver ? (
            <div style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              top: 1,
              fontSize: 18,
              color: COLORS.grey,
              width: '100%',
              backgroundColor: COLORS.blue,
              height: 38
            }}>
              { placeholderText }
            </div>
          ) : null}

          {provided.placeholder}
          </div>
        )}
    </Droppable>
  )
}

export default Sandbox;



// WEBPACK FOOTER //
// ./src/components/workouts/Sandbox.js